import useCheckProductCompletionForPublish from './useCheckProductCompletionForPublish'

export default useCheckProductCompletionForPublish
